const addRecentlyViewed = () => {
  const productHandle = window.location.pathname.match(/\/products\/([a-zA-Z0-9\-]+)/);
  if (!productHandle || !productHandle[1]) return;
  const handle = productHandle[1];

  let viewed = localStorage.getItem('shopify_recently_viewed');
  viewed = viewed ? JSON.parse(viewed) : [];

  if (viewed.includes(handle)) {
    viewed = viewed.filter(h => h !== handle);
  }
  
  viewed.unshift(handle);
  if (viewed.length > 5) {
    viewed = viewed.slice(0, 5);
  }
  
  localStorage.setItem('shopify_recently_viewed', JSON.stringify(viewed));
};

const renderRecentlyViewed = () => {
  const container = document.querySelector('[data-recently-viewed-container]');
  if (!container) return;

  let viewed = localStorage.getItem('shopify_recently_viewed');
  viewed = viewed ? JSON.parse(viewed) : [];

  const currentProductHandle = window.location.pathname.match(/\/products\/([a-zA-Z0-9\-]+)/);
  if (currentProductHandle && currentProductHandle[1]) {
    viewed = viewed.filter(h => h !== currentProductHandle[1]);
  }

  if (viewed.length === 0) {
    return;
  }

  container.closest('.recently-viewed-section').style.display = 'block';

  let queries = viewed.map(handle => fetch(`/products/${handle}?view=card`).then(res => res.text()));
  
  Promise.all(queries).then(htmlArray => {
    container.innerHTML = `<ul class="grid product-grid grid--4-col-desktop grid--2-col-tablet-down">
      ${htmlArray.map(html => `<li class="grid__item">${html}</li>`).join('')}
    </ul>`;
  }).catch(err => {
    container.innerHTML = '';
  });
};

document.addEventListener('DOMContentLoaded', () => {
  addRecentlyViewed();
  renderRecentlyViewed();
});
